import React, { useEffect, useRef, useState } from "react";
import { usePDF, Margin } from 'react-to-pdf';
import { Form, Table, Select, Button } from "antd";
import { ResponsiveBar } from '@nivo/bar'
import ProgressModal from '../../../../App/Utils/ProgressModal'
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import { DataProvider } from "../../../DataProvider";
import { FEEDBACK_REPORT_COLUNMN_DEFS } from "../../../Constants";

var _ = require('lodash');

const MonthlyReport = (props) => {
    const formRef = useRef();
    const dataProvider = new DataProvider();

    const [showProgress, setShowProgress] = useState(false)
    const [mstProject, setMstProject] = useState([])
    const [selectedProject, setSelectedProject] = useState(null)
    
    const [evaluationPeriodOptions, setEvaluationPeriodOptions] = useState([])
    const [evaluationPeriod, setEvaluationPeriod] = useState('')

    const [feedbackData, setFeedbackData] = useState([])
    const [filteredFeedbackData, setFilteredFeedbackData] = useState([])
    
    const [feedbackBarChartData, setFeedbackBarChartData] = useState([])
    const [filteredFeedbackBarChartData, setFilteredFeedbackBarChartData] = useState([])

    const { toPDF, targetRef } = usePDF({
        filename: 'page.pdf',
        page: {
            margin: Margin.SMALL,
            format: 'A4',
        },
    });
    
    const fetchDropdownValues = () => {
        ['MstProject'].forEach((model, index) => {
            dataProvider.getDropdownValues(model)
                .then((response) => {
                    if (response.ok) {
                        response.json().then((data) => {
                            setMstProject(data.results)
                        })
                    } else {
                        response.json().then((responseJson) => {
                            openNotification("error", "Error", responseJson["message"]);
                        });
                    }
                }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
        })
    }

    useEffect(() => { }, [feedbackData])
    useEffect(() => { fetchDropdownValues() }, [])

    useEffect(()=>{
        let filterFeedbackData = feedbackData.filter(item=>item['evaluation_period']==evaluationPeriod)
        let filterFeedbackChartData = feedbackBarChartData.filter(item=>item['evaluation_period']==evaluationPeriod)
        if(selectedProject){
            filterFeedbackData = filterFeedbackData.filter(item=>item['project']==selectedProject)
            filterFeedbackChartData = filterFeedbackChartData.filter(item=>item['project']==selectedProject)
        }
        setFilteredFeedbackData(filterFeedbackData)
        setFilteredFeedbackBarChartData(filterFeedbackChartData)
    },[evaluationPeriod])

    useEffect(()=>{
        let filterFeedbackData = feedbackData.filter(item=>item['project']==selectedProject)
        let filterFeedbackChartData = feedbackBarChartData.filter(item=>item['project']==selectedProject)
        if(selectedProject){
            filterFeedbackData = filterFeedbackData.filter(item=>item['evaluation_period']==evaluationPeriod)
            filterFeedbackChartData = filterFeedbackChartData.filter(item=>item['evaluation_period']==evaluationPeriod)
        }
        setFilteredFeedbackData(filterFeedbackData)
        setFilteredFeedbackBarChartData(filterFeedbackChartData)
    },[selectedProject])

    
    useEffect(() => {
        setShowProgress(true)
        dataProvider.getMonthlyFeedbackReport()
            .then(response => {
                if (response.ok) {
                    response.json().then(responseJson => {
                        setShowProgress(false)
                        setFeedbackData([...responseJson['results']])
                        setFilteredFeedbackData([...responseJson['results']])
                        const chatData = responseJson['results'].map(item => {
                            return {
                                "contractor_code": item['contractor_code'],
                                "project": item['project'],
                                "evaluation_period": item['evaluation_period'],
                                "Safety": parseFloat(item['Safety']).toFixed(2),
                                "Quality": parseFloat(item['Quality']).toFixed(2),
                                "Time Schedule": parseFloat(item['Time Schedule']).toFixed(2),
                                "Discipline & Compliance": parseFloat(item['Discipline & Compliance']).toFixed(2),
                                "Improvement & Initiative": parseFloat(item['Improvement & Initiative']).toFixed(2),
                            }
                        })
                        setFeedbackBarChartData([...chatData])
                        setEvaluationPeriodOptions([...new Set(responseJson['results'].map(item => item['evaluation_period']))])
                        if (Object.values(responseJson['results']).length == 0) {
                            openNotification("error", "Error", "No feedback found!")
                        } else {
                            openNotification("success", "Success", responseJson["message"])
                        }
                    })
                } else {
                    setShowProgress(false)
                    response.json().then(responseJson => {
                        openNotification("error", "Error", responseJson["message"])
                    })
                }
            }).catch(error => {
                setShowProgress(false)
                openNotification("error", "Error", "Error connecting server")
            })
    }, [])

    return (
        <div ref={targetRef}>
            <ProgressModal showProgress={showProgress} />
            <Form
                className="ant-form ant-form-vertical"
                ref={formRef}
            >
                <div className="row form-box" style={{ paddingTop: "10px" }}>
                    <div className="col-lg-4 col-md-12">
                        <Form.Item
                            name={"evaluation_period"}
                            label="Evaluation Period" >
                            <Select
                                style={{ width: "100%" }}
                                onChange={(x)=>{
                                    setEvaluationPeriod(x)
                                }}
                                options={evaluationPeriodOptions.map(item=>{
                                    return {
                                        value:item,
                                        label: item
                                    }
                                })}>
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <Form.Item
                            name={"project"}
                            label="Project"
                            rules={[{ required: true, message: "Please select project" }]}>
                            <Select
                                style={{ width: "100%" }}
                                allowClear
                                showSearch
                                placeholder="Select Project"
                                onChange={(x)=>{
                                    setSelectedProject(x)
                                }}
                                options={mstProject.map((val) => ({
                                    value: val.project_id,
                                    label: val.project_name,
                                }))} />
                        </Form.Item>
                    </div>
                    <div className="col-lg-2 col-md-12">
                        <div style={{ marginTop: "28px" }}>
                            <Button
                                onClick={() => {
                                    openNotification("warning", "Export to PDF", "Please wait, file will download shortly")
                                    toPDF()
                                }}
                                type="primary"
                            >
                                Download Report
                            </Button>
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12" style={{height:"500px"}}>
                        <ResponsiveBar
                            data={filteredFeedbackBarChartData}
                            keys={[
                                'Safety',
                                'Quality',
                                'Time Schedule',
                                'Discipline & Compliance',
                                'Improvement & Initiative',
                            ]}
                            indexBy="contractor_code"
                            margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                            padding={0.3}
                            groupMode="grouped"
                            valueScale={{ type: 'linear' }}
                            colors={{ scheme: 'nivo' }}
                            borderColor={{
                                from: 'color',
                                modifiers: [
                                    [
                                        'darker',
                                        1.6
                                    ]
                                ]
                            }}
                            axisTop={null}
                            axisRight={null}
                            axisBottom={{
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: 0,
                                legend: 'Suppliers',
                                legendPosition: 'middle',
                                legendOffset: 32,
                                truncateTickAt: 0
                            }}
                            axisLeft={{
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: 0,
                                legend: 'Score',
                                legendPosition: 'middle',
                                legendOffset: -40,
                                truncateTickAt: 0
                            }}
                            labelSkipWidth={12}
                            labelSkipHeight={12}
                            labelTextColor={{
                                from: 'color',
                                modifiers: [
                                    [
                                        'darker',
                                        1.6
                                    ]
                                ]
                            }}
                            legends={[
                                {
                                    dataFrom: 'keys',
                                    anchor: 'bottom-right',
                                    direction: 'column',
                                    justify: false,
                                    translateX: 120,
                                    translateY: 0,
                                    itemsSpacing: 2,
                                    itemWidth: 100,
                                    itemHeight: 20,
                                    itemDirection: 'left-to-right',
                                    itemOpacity: 0.85,
                                    symbolSize: 20,
                                    effects: [
                                        {
                                            on: 'hover',
                                            style: {
                                                itemOpacity: 1
                                            }
                                        }
                                    ]
                                }
                            ]}
                            role="application"
                        />
                    </div>
                    <div className="col-lg-12 col-md-12" style={{ marginBottom: "20px", marginTop: "10px" }}>
                        <Table
                            size="small"
                            bordered={true}
                            columns={_.cloneDeep(FEEDBACK_REPORT_COLUNMN_DEFS)}
                            pagination={false}
                            dataSource={_.cloneDeep(filteredFeedbackData)}
                        />
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default MonthlyReport;
